import { Component, ContentChild, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { IOption } from '../../../models/IOption';
import { AccordionRowBodyComponent } from '../accordion-row-body/accordion-row-body.component';
import { AccordionCellComponent } from '../accordion-cell/accordion-cell.component';

@Component({
  selector: 'ff-accordion-row',
  template: '',
  styleUrls: ['./accordion-row.component.scss']
})
export class AccordionRowComponent implements OnInit {

  /// Id of the row for the checkbox
  @Input() id: string;

  /// Custom height of the row panel
  @Input() height: string = "60px";

  /// Event emitter on row checkbox selection
  @Output() selected = new EventEmitter<IOption>()

  /// Event emitter on panel opening
  @Output() opened = new EventEmitter<string>();

  /// Event emitter on panel closing
  @Output() closed = new EventEmitter<string>();

  ///Templates for the cells of the table row
  @ContentChildren(AccordionCellComponent) cellTemplates: QueryList<AccordionCellComponent>;

  ///Template for the body element of the expandable panel
  @ContentChild(AccordionRowBodyComponent) bodyTemplate: AccordionRowBodyComponent;

  /// The associated template
  @ViewChild('rowTemplate') public rowTemplate: TemplateRef<any>;

  ///Checkbox option for this element
  option: IOption;

  constructor() { }

  ngOnInit(): void {
    this.option = {
      value: this.id,
      text: ""
    }
  }

  onSelected(event: IOption[]) {
    this.selected.emit(event[0]);
  }

  onOpened(event: any) {
    this.opened.emit(this.id);
  }

  onClosed(event: any) {
    this.closed.emit(this.id);
  }
}
